import React, { useEffect } from 'react';
import Modal from 'jd-library/Modal';
import ImageIcons from 'jd-library/ImageIcons';
import './ai-product-modal.scss';
import withPortal from 'jd-library/withPortal'
import { useDispatch } from 'react-redux';
import { toggleAICreationModal } from '../actions/products';

const AISuccessModal = () => {
    const dispatch = useDispatch();
    const closeModal = () => dispatch(toggleAICreationModal({ successModal: {show: false} }));

    useEffect(() => {
        const timer = setTimeout(() => {
            window.history.back();
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Modal
            settings={{
                modalId: 'ai-product-success-modal',
                class: 'ai-product-success-modal',
                variant: 'action'
            }}
            onHidden={closeModal}
        >
            <Modal.Body>
                <div className="ai-success-body">
                    <div className="ai-success-illustration">
                        <img
                            className="ai-check-icon"
                            src={ImageIcons.CHECK_MARK_GIF}
                            alt="success"
                        />
                    </div>
                    <div className="ai-success-title">
                        Perfect! 🎉
                    </div>
                    <p className="ai-success-subtitle">
                        Your products are being processed. In few minutes, we will send you the link on WhatsApp for approval.
                    </p>
                </div>        
            </Modal.Body>
        </Modal>
    )
}

export default withPortal(AISuccessModal);
